<template>
  <div>
    <div class="animated fadeIn" v-if="hsn_rights === true">
      <div class="row">
        <p v-show="hide">{{ hsn_view }}</p>
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="title_head">Add HSN</div>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <div class="row error_msg">
                  <div class="col-sm-12 alert alert-success " v-if="message.sucess!=''" style="text-align:center;">{{message.sucess}}</div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group" >
                      <label for="name">HSN Code : <span class="star">*</span></label>
                      <b-form-input ref="txthsnid" type="text" class="form-control" @blur.native="chkExist()" v-model="hsnid" :class="{'is-invalid':error.errorhsn}" placeholder="Enter HSN Id"></b-form-input>
                      <small class="form-text text-muted" v-if="error.errorhsn"><strong style="color: red;">{{error.errorhsn}}</strong></small>
                     </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="name">Tax: <span class="star">*</span></label>
                      <model-list-select :list="taxlist2" option-value="tax_id" option-text="tax_name" v-model="selectedtax2" placeholder="Select Tax"></model-list-select>
                      <small  class="form-text text-muted" v-if="error.errortx" ><strong style="color: red;">Please Select Tax Id</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group" >
                      <label for="name">Chapter Code : <span class="star">*</span></label>
                       <input type="text" class="form-control"   v-model="hsncode" placeholder="Enter Chapter Code Name" > 
                        <small  class="form-text text-muted" v-if="error.errorhsncd" ><strong style="color: red;">Enter Numeric Value</strong></small>
                     </div>
                  </div>
                </div>
                <div class="row">                 
                  <div class="col-sm-12">
                    <div class="form-group" >
                      <label for="name">HSN Description : <span class="star">*</span></label>
                      <textarea type="text" class="form-control" v-model="hsndsc" placeholder="Enter HSN Description" ></textarea> 
                      <small class="form-text text-muted" v-if="error.errordes" ><strong style="color: red;">Enter HSN Description</strong></small>
                     </div>
                  </div>                
                </div>
              </b-card-body>
              <div class="card-footer">
                <div class="row">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-sm btn-primary"  @click.prevent="savehsn()"><i class="fa fa-dot-circle-o"></i> Save</button>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="title_head">HSN List Table</div>
            </div>
            <div class="card-body">
              <vue-good-table 
              :columns="columns" 
              :rows="rows" 
              mode="remote"
              ref="my-table"
              :pagination-options="{
                    enabled: true,
                    perPage: 5,
                                }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              styleClass="vgt-table striped bordered table-sm condensed">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'action'">
                    <span v-if="hsn_rights === true">
                        <span v-if="props.row.company_id !== 'I2OCGLB'">
                          <i class="fa fa-edit" @click.prevent="edithsn(props.row)"></i>
                          <i class="fa fa-trash" @click.prevent="deletehsn(props.row)"></i>
                        </span>
                        <span v-else>
                           <span v-if="is_admin === true">
                              <i class="fa fa-edit" @click.prevent="edithsn(props.row)"></i>
                              <i class="fa fa-trash" @click.prevent="deletehsn(props.row)"></i>
                            </span>
                            <span v-else>
                              <i class="fa fa-edit" @click.prevent="viewhsn(props.row)" style="color:lightblue !important;"></i>
                              <i class="fa fa-trash" style="color:grey !important;"></i>
                            </span>
                        </span>
                      </span>
                      <span v-else>
                        <i class="fa fa-edit" style="color:grey !important;"></i>
                        <i class="fa fa-trash" style="color:grey !important;"></i>
                      </span>
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Edit HSN" no-close-on-esc no-close-on-backdrop hide-footer size="lg" class="modal-info" v-model="warningModal" @ok="warningModal = false" ok-variant="warning">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" >
            <label for="name">HSN ID : <span class="star">*</span></label>
            <input type="text" class="form-control" v-model="hsnided"  placeholder="Enter HSN Id"> 
            <small  class="form-text text-muted" v-if="error.errorhsned" ><strong style="color: red;">Enter Numeric Value</strong></small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" >
            <label for="name">Tax ID : <span class="star">*</span></label>
            <model-list-select :list="taxlist1" option-value="tax_id" option-text="tax_name" v-model="selectedtax1" placeholder="Select Tax"></model-list-select>
            <small class="form-text text-muted" v-if="error.errortxed" >
            <strong style="color: red;">Please Select Tax</strong>
            </small>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" >
            <label for="name">Chapter Code : <span class="star">*</span></label>
            <input type="text" class="form-control"   v-model="hsncodeed" placeholder="Enter Chapter Code Name" > 
            <small  class="form-text text-muted" v-if="error.errorhsncded" ><strong style="color: red;">Enter Numeric Value</strong></small>
          </div>
        </div>
      </div>
      <div class="row">                 
        <div class="col-sm-12">
          <div class="form-group" >
            <label for="name">HSN Description : <span class="star">*</span></label>
            <textarea type="text" class="form-control" v-model="hsndsced" placeholder="Enter HSN Discription"></textarea>
            <small class="form-text text-muted" v-if="error.errordesed"><strong style="color: red;">Enter HSN Description</strong></small>
          </div>
        </div>                
      </div>
      <div class="col-md-12">
        <button type="submit" class="btn btn-sm btn-primary"  @click.prevent="savehsned()"><i class="fa fa-dot-circle-o"></i> Save</button>
      </div>
    </b-modal>

    <b-modal title="View HSN" no-close-on-esc no-close-on-backdrop hide-footer size="lg" class="modal-info" v-model="warningModal1" @ok="warningModal1 = false" ok-variant="warning">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" >
            <label for="name">HSN ID :</label>
            <input type="text" class="form-control" v-model="hsnided" disabled placeholder="Enter HSN Id"> 
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" >
            <label for="name">Tax ID :</label>
            <model-list-select :list="taxlist1" :isDisabled= true option-value="tax_id" option-text="tax_name" v-model="selectedtax1" placeholder="Select Tax"></model-list-select>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" >
            <label for="name">Chapter Code :</label>
            <input type="text" class="form-control" disabled v-model="hsncodeed" placeholder="Enter Chapter Code Name" > 
          </div>
        </div>
      </div>
      <div class="row">                 
        <div class="col-sm-12">
          <div class="form-group" >
            <label for="name">HSN Description :</label>
            <textarea type="text" class="form-control" disabled v-model="hsndsced" placeholder="Enter HSN Discription"></textarea>
          </div>
        </div>                
      </div>
    </b-modal>

    <Spinner v-if="loading"></Spinner> 
  </div>
</template>

<script>
import Spinner from '../../spinner.vue'
export default {
  name: 'HSN',
  components: { Spinner },
  data(){
    return {
      // pg_view:false,
      // pg_rights:false,
      is_admin:false,
      shpfrst_time:false,
		  hfrst_time:false,
		  sfrst_time:false,
      hide:false,
      warningModal:false,
      warningModal1:false,
      loading:false,
      hsnid:'',
      hsncode:'',
      hsndsc:'', 
      hsnided:'',
      selectedtax1:null,
      selectedtax2:null,
      taxlist1:[],
      taxlist2:[],
      hsncodeed:'',
      hsndsced:'', 
      taxed:'', 
      totalRecords: 0,
      serverParams: {
      columnFilters: {
                   },
        sort: {},
        page: 1, 
        perPage: 5
      },
      columns: [
      {
        label: 'HSN Code',
        field: 'hsn_code',
        width: '20% !important'
      },
      {
        label: 'Chapter Code',
        field: 'chapter_code',
        width: '15% !important'
      },
      {
        label: 'HSN Description',
        field: 'hsn_desc',
        width: '45% !important',
      },
      {
        label: 'Action',
        field: 'action',
        width: '20% !important'
      },
      ],
      rows:[],
      error:{
        errorhsn:false,
        errortx:false,
        errorhsncd:false,
        errordes:false,
        errorhsned:false,
        errortxed:false,
        errorhsncded:false,
        errordesed:false,
      },
      message:{
        sucess:'',
      }
    };
  },
  computed:{
    hsn_view: function(){
      if(this.$store.getters.get_hsn_view === true){
          this.shopuser('comp');
          this.getselect('comp');
          this.gethsn('comp');
          this.is_admin = this.$store.getters.get_is_admin
          return true
      }
      else{
        return false
      }
    },
    hsn_rights: function(){
      return this.$store.getters.get_hsn_rights
    }
  },
  // created(){

  //   var roles = JSON.parse(localStorage.getItem('roles'))
  //   for (var i = 0; i < roles.length; i++) {
  //     if(roles[i].page_name == 23){
  //       this.pg_view = roles[i].view
  //       this.pg_rights = roles[i].rights
  //       if(this.pg_view){
  //         this.shopuser();
  //         this.getselect();
  //         this.gethsn();
  //       }
  //     }
  //   }
  // },

  methods:{
    chkExist(){
        var number=/^[0-9]{1,10}$/
        this.hsnid = this.hsnid.trim()
        if(this.hsnid !== ''){
          if(number.test(this.hsnid)==false){
            this.error.errorhsn="Enter numeric value"     
          }
          else{
            var _this = this
            this.$http.get('/api/hsns/chk_exist?filter[where][hsncode]='+this.hsnid).then(function (response){
              if(response.data.length > 0){
                _this.hsnid = ''
                _this.error.errorhsn = 'Hsn Code already exist'
                _this.$refs["txthsnid"].focus()
              }
              else{
                _this.error.errorhsn = false
              }
            })
            .catch(function(error){
              _this.error.errorhsn = false
            });
          }
        }
        else{
           this.error.errorhsn = false
        }
      },
    shopuser(val){
      if(val === 'comp'){
          if(this.shpfrst_time === false){
            this.shpfrst_time = true
          }
          else{
            return
          }
        }
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){

      }).catch(function(error){
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },
    updateParams(newProps) {
          this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
    
    onPageChange(params) { 
           this.updateParams({page: params.currentPage});
           this.gethsn();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.gethsn();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.gethsn();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.gethsn();
    },

    getselect(val){
      if(val === 'comp'){
          if(this.sfrst_time === false){
            this.sfrst_time = true
          }
          else{
            return
          }
        }
      var _this=this;
      this.$http.get('/api/taxrates').then(function(response){
        _this.taxlist1=response.data;
        _this.taxlist2=response.data;
      }).catch(function(error){
        console.log(error.response)
      })
    },

    gethsn(val){
      if(val === 'comp'){
          if(this.hfrst_time === false){
            this.hfrst_time = true
          }
          else{
            return
          }
        }
      var _this=this
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.loading = true
      this.$http.get('/api/hsns?params='+JSON.stringify(filteParam)).then(function(response){
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift()
        if(response.data != undefined)
        _this.rows=response.data  
        _this.loading =false
      }).catch(function(error){
        console.log(error.response)
        _this.message.sucess="SomeThing Went Wrong"
      })
    },

    savehsn(){
      var _this=this;   
      var submit=this.validation();
      if(submit==0){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading=true;
        this.error.errorhsn=false; 
        this.error.errortx=false; 
        this.error.errorhsncd=false; 
        this.error.errordes=false; 
        _this.warningModal=false;
        var data={
          hsn_code:this.hsnid,
          tax_id:this.selectedtax2.tax_id,
          chapter_code:this.hsncode,
          hsn_desc:this.hsndsc,
        }
        this.$http.post('/api/hsns',data).then(function(response){
          _this.loading=false;
          _this.message.sucess="HSN Added Successfully";
          setTimeout(function(){ _this.message.sucess=false;}, 2000);
          _this.gethsn();
          _this.reset();
        }).catch(function(error){
          console.log(error.response)
          _this.loading=false;
          _this.message.sucess="SomeThing Went Wrong"
        })
      }
    },

    savehsned(){
      var _this=this;   
      var submit=this.validationed();
      if(submit==0){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading=true;
         
        _this.warningModal=false;
        var data={
          hsn_code:this.hsnided,
          tax_id:this.selectedtax1,
          chapter_code:this.hsncodeed,
          hsn_desc:this.hsndsced,
        }
        this.$http.post('/api/hsns/update?where[id]='+this.taxed,data).then(function(response){
          _this.loading=false;
          _this.message.sucess="HSN updated Successfully";
          setTimeout(function(){ _this.message.sucess=false;}, 2000);
          _this.gethsn();
          _this.reset();
        }).catch(function(error){
          console.log(error.response)
          _this.loading=false;
          _this.message.sucess="SomeThing Went Wrong"
        })
      }
    },

    edithsn(val){
      this.error.errorhsn=false
      this.error.errortx=false
      this.error.errorhsncd=false
      this.error.errordes=false
      this.warningModal=true;
      this.taxed=val.hsn_id;
      this.hsnided=val.hsn_code;
      this.selectedtax1=val.tax_id;
      this.hsncodeed=val.chapter_code;
      this.hsndsced=val.hsn_desc;
    },

    viewhsn(val){
      this.warningModal1=true;
      this.taxed=val.hsn_id;
      this.hsnided=val.hsn_code;
      this.selectedtax1=val.tax_id;
      this.hsncodeed=val.chapter_code;
      this.hsndsced=val.hsn_desc;
    },

    deletehsn(val){
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        this.loading=true
        var _this=this
        var id =val.id;
        this.$http.delete('/api/hsns/'+id).then(function (response) {
          _this.loading=false
          _this.gethsn();
        })
        .catch(function (error) {
          _this.loading=false
          console.log(error);
        });
      }
    },

    validation(){
      var number=/^[0-9]{1,10}$/
      var submit=0
      this.error.errorhsn=false
      this.error.errortx=false
      this.error.errordes=false
      this.error.errorhsncd=false
      // if(number.test(this.hsnid)==false){
      //   this.error.errorhsn="Enter numeric value"     
      //   submit=1   
      // }
      if(this.selectedtax2 == undefined && this.selectedtax2 == ''){
        this.error.errortx=true  
        submit=1       
      }
      if(this.selectedtax2 == null){
        this.error.errortx=true  
        submit=1       
      }
      if(this.hsndsc == ''){
        this.error.errordes=true  
        submit=1
      }
      if(number.test(this.hsncode)==false){
        this.error.errorhsncd=true  
        submit=1       
      }
      return submit;
    },

    validationed(){
      this.error.errorhsned=false; 
      this.error.errortxed=false; 
      this.error.errorhsncded=false; 
      this.error.errordesed=false;
      var number=/^[0-9]{1,10}$/
      var submit=0
      if(number.test(this.hsnided)==false){
        this.error.errorhsned=true     
        submit=1   
      }
      if(this.selectedtax1==null){
        this.error.errortxed=true  
        submit=1
      }
      if(this.selectedtax1==undefined && this.selectedtax1==null ){
        this.error.errortxed=true  
        submit=1       
      }
      if(number.test(this.hsncodeed)==false){
        this.error.errorhsncded=true  
        submit=1       
      }
      if(this.hsndsced == ''){
        this.error.errordesed=true  
        submit=1
      }
     return submit;
      },
         reset(){
            this.hsnid='';
            this.selectedtax2=null;
            this.hsncode='';
            this.hsndsc='';
 
       }
    }
};
</script>


      <style type="text/css">
  
        .modal-header{
          background-color: #1a94cb;
          columns: #fff;
        }
        .multiselect__tags{
          border-radius: 0px !important;
          border: 0px solid #3e515b; 
        }
      </style>



// WEBPACK FOOTER //
// src/views/setting/HSN.vue